import React from 'react'
import { useTranslation } from 'react-i18next'
import Text from '@navent-jobs/ui-kit/components/text'
import { ZonajobsPostularWrapper, CustomButtonForZonajobs, ZonajobsWordingContainer } from './mixins'

const Component = ({ id }) => {
  const { t } = useTranslation()

  function handleUlrAvisoZonajobs() {
    const dinamicUrl = window.open(
      `https://www.zonajobs.com.ar/empleos/-${id}.html?utm_source=bumeran&utm_medium=free&utm_campaign=crossbrand`
    )
    return dinamicUrl
  }

  return (
    <ZonajobsPostularWrapper>
      <ZonajobsWordingContainer>
        <Text size="sm">
          {t(
            'Este aviso fue publicado por ZonaJobs. El botón te dirigirá al aviso completo, desde donde te podrás postular.'
          )}
        </Text>
      </ZonajobsWordingContainer>

      <CustomButtonForZonajobs
        buttonoptions={{ variant: 'zonajobs', block: true }}
        onClick={() => handleUlrAvisoZonajobs()}
      >
        {t('Postularme en ZonaJobs')}
      </CustomButtonForZonajobs>
    </ZonajobsPostularWrapper>
  )
}

export default Component
